import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { useActiveColorScheme } from "@m/alchemy-theme";
import { ArrowLeftIcon } from "../icons/ArrowLeftIcon";
import { ArrowRightIcon } from "../icons/ArrowRightIcon";
import { PaginationPage } from "./PaginationPage";
export const PaginationArrow = forwardRef((props, ref) => {
    const { ariaLabel, arrow, href, isDisabled, onPageClick, pageObject, size, ...otherProps } = props;
    const ArrowIcon = arrow === "next" ? ArrowRightIcon : ArrowLeftIcon;
    const activeColorScheme = useActiveColorScheme();
    return (_jsx(PaginationPage, { ref: ref, "data-testid": "PaginationArrow", arrow: arrow, isDisabled: isDisabled, ariaLabel: ariaLabel, href: href, pageObject: pageObject, onPageClick: onPageClick, size: size, ...otherProps, children: _jsx(ArrowIcon, { size: size === "small" ? 20 : 24, color: isDisabled ? "highlight" : activeColorScheme === "alchemyBrand" ? "inverse" : "base", palette: isDisabled ? "interactiveNavigational" : "interactiveConstructive", "aria-hidden": "true" }) }));
});
PaginationArrow.displayName = "PaginationArrow";
PaginationArrow.defaultProps = {
    isDisabled: false,
    size: "large"
};
